var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55699 0.0796953C8.83825 -0.0265651 9.16171 -0.0265651 9.44297 0.0796953L17.3184 3.07999C17.8106 3.26751 18.0848 3.7363 17.9758 4.19885C17.8704 4.66452 17.4098 4.9708 16.8437 4.99893V5.24895C16.8437 5.66462 16.4992 5.99902 16 5.99902H1.93672C1.50076 5.99902 1.09293 5.66462 1.09293 5.24895V4.99893C0.590165 4.9708 0.129594 4.66452 0.0241201 4.19885C-0.0848699 3.7363 0.192879 3.26751 0.681576 3.07999L8.55699 0.0796953ZM8.99998 3.99883C9.62228 3.99883 10.125 3.55191 10.125 2.99873C10.125 2.44555 9.62228 1.99863 8.99998 1.99863C8.37768 1.99863 7.87492 2.44555 7.87492 2.99873C7.87492 3.55191 8.37768 3.99883 8.99998 3.99883ZM4.4681 12.9997H5.87443V6.99912H8.12454V12.9997H9.84377V6.99912H12.0939V12.9997H13.5002V6.99912H15.7503V13.1341C15.7714 13.1435 15.7925 13.1278 15.8136 13.1685L17.5012 14.1686C17.9126 14.4123 18.0954 14.8686 17.9512 15.2906C17.8071 15.7125 17.3711 16 16.8754 16H1.09293C0.628839 16 0.192879 15.7125 0.0487308 15.2906C-0.0954174 14.8686 0.0874047 14.4123 0.50227 14.1686L2.18986 13.1685C2.21095 13.1278 2.23205 13.1435 2.21798 13.1341V6.99912H4.4681V12.9997Z",
    fill: "#4EEC91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.45a2654abb54d823249cb2dde48b8b39.svg";
export { ForwardRef as ReactComponent };